import { HomeWrap } from "./HomeWrap";
import mascot from "@/assets/mascot-happy-224.png";

export function HomeTrust() {
  return (
    <section className="border-y border-[#E2D5C0] bg-[#F2EADC] py-[84px] max-[820px]:py-[58px]">
      <HomeWrap className="grid gap-[34px] min-[900px]:grid-cols-[200px_1fr] min-[900px]:items-start min-[900px]:gap-[60px]">
        <div>
          <img
            src={mascot}
            alt=""
            aria-hidden="true"
            width={224}
            height={290}
            loading="lazy"
            className="w-[170px] object-contain max-[899px]:w-[120px]"
          />
        </div>
        <div>
          <h2 className="max-w-[30ch] font-display text-[clamp(28px,3.4vw,38px)] font-semibold leading-[1.1] tracking-[-0.015em] text-[#3B2314]">
            Scored by people who need the outlet too.
          </h2>
          <p className="mt-[22px] max-w-[60ch] text-[17.5px] leading-[1.6] text-[#7B4F2E]">
            We're remote workers. We built Grounded because working out whether somewhere was work
            friendly meant reading reviews, zooming into photos hunting for outlets, and still not
            knowing until you arrived.
          </p>
          <p className="mt-[18px] max-w-[60ch] text-[17.5px] leading-[1.6] text-[#7B4F2E]">
            We check the things that don't change, like whether there's parking out back. We don't
            score the coffee.
          </p>
          <p className="mt-[18px] max-w-[60ch] text-[17.5px] leading-[1.6] text-[#7B4F2E]">
            A score isn't the whole story either. A café that was quiet in March can be all laptops
            by June. That's what the live conditions are for, and why something reported an hour ago
            beats a score from last spring.
          </p>
        </div>
      </HomeWrap>
    </section>
  );
}
